import { reactive } from 'vue'

export const store = reactive({
  roomId: undefined,
  setRoomId(roomId) {
    this.roomId = roomId
  },

  amountOfTicketsInHistory: 0,
  setAmountOfTicketsInHistory(amount){
    this.amountOfTicketsInHistory = amount
  }
})
